import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  DYNAMIC_COMPONENT_DATA,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { ITransactionExtendedDataDisplayData } from '../../../transactions-display/transaction-display/transaction-display-line/transaction-display-line.component';
import { IMohExtendedData } from '@principle-theorem/principle-core/interfaces';

@Component({
  selector: 'pr-moh-extended-data',
  imports: [NgCommonModule],
  templateUrl: './moh-extended-data.component.html',
  styleUrl: './moh-extended-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohExtendedDataComponent {
  data = inject<ITransactionExtendedDataDisplayData<IMohExtendedData>>(
    DYNAMIC_COMPONENT_DATA
  );
}
